import type { AggregationColumnOption } from 'flow/store/engine/types/props';
import type { DropdownOption } from '~/flow/types';
import type { AggregationType } from 'flow/store/engine/constants';
import { AGGREGATION_TYPE_LABELS } from './constants';

export const isPublishedAttribute = (uiDataType: string): boolean => uiDataType === 'published_attribute';

/**
 * Derives the aggregation-type dropdown options from the selected column.
 * Returns an empty array when no column is selected or the column has no
 * allowed aggregation types.
 */
export function getAggregationTypeOptions(
  columnOptions: AggregationColumnOption[],
  selectedColumnSlug: string,
): DropdownOption[] {
  const selected = columnOptions.find(col => col.value === selectedColumnSlug);
  if (!selected) return [];
  return selected.aggregations.map(type => ({
    label: AGGREGATION_TYPE_LABELS[type] ?? type,
    value: type,
  }));
}

/**
 * Returns the current aggregationType if it is still valid for the new column,
 * otherwise falls back to the first allowed type for that column.
 */
export function reconcileAggregationType(
  columnOptions: AggregationColumnOption[],
  newColumnSlug: string,
  currentAggregationType: AggregationType,
): AggregationType {
  const col = columnOptions.find(c => c.value === newColumnSlug);
  if (!col) return currentAggregationType;
  return col.aggregations.includes(currentAggregationType)
    ? currentAggregationType
    : col.aggregations[0] ?? currentAggregationType;
}

